import { jsx } from "react/jsx-runtime";
import { cleanProps, cn } from "../../utils/index.js";
import { Span } from "../Text/Span.js";
import { reviewBadgeVariants } from "./ReviewBadge.variants.js";
function ReviewBadge({ rating, className, onClick, ...props }) {
    const { badgeSlot, textSlot } = reviewBadgeVariants(props);
    const classes = cn(badgeSlot(), className);
    const domProps = cleanProps(props, [
        'size'
    ]);
    if (onClick) return /*#__PURE__*/ jsx("button", {
        type: "button",
        className: classes,
        onClick: onClick,
        ...domProps,
        children: /*#__PURE__*/ jsx(Span, {
            className: textSlot(),
            bold: true,
            align: "center",
            children: rating
        })
    });
    return /*#__PURE__*/ jsx("div", {
        className: classes,
        ...domProps,
        children: /*#__PURE__*/ jsx(Span, {
            className: textSlot(),
            bold: true,
            align: "center",
            children: rating
        })
    });
}
export { ReviewBadge };
